import { Select } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useIntlApi } from '../../../hooks';
import { SelectProps } from '@mantine/core';
import classes from './Inputs.module.css';

interface CountrySelectProps extends SelectProps {
  name?: string;
  value?: string;
  onChange?: (value: string | null) => void;
  error?: string;
}

export const CountrySelect = ({
  name,
  value,
  onChange,
  error,
  ...props
}: CountrySelectProps) => {
  const { t } = useTranslation();
  const { localizedCountryList } = useIntlApi();

  return (
    <Select
      label={t('documents.create.country') as string}
      placeholder={t('documents.create.country') as string}
      data={localizedCountryList}
      searchable
      value={value}
      onChange={onChange}
      error={error}
      {...props}
      classNames={{
        root: classes.darkBackground,
        wrapper: classes.darkBackground,
        input: classes.darkBackground,
        dropdown: classes.darkBackground,
      }}
    />
  );
};
